import { Component, ContentChildren, ElementRef, EventEmitter, Input, AfterViewInit, Output, QueryList, ViewChildren, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { Observable } from 'rxjs';

import { CompareDirection } from 'src/app/_apps/app.constants';
import { ColumnHeaderItemComponent } from './column-header-item/column-header-item.component';

@Component({
    selector: 'aa-column-header-group',
    templateUrl: './column-header-group.component.html',
    styleUrls: [
        './column-header-group.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ColumnHeaderGroupComponent implements AfterViewInit, OnChanges
{
    @Input() isLoaded: Observable<boolean>;
    @Input() initSorterKey: string;
    @Input() direction: CompareDirection;
    public uiDirection: number;
    @ContentChildren(ColumnHeaderItemComponent) columnHeaders: QueryList<ColumnHeaderItemComponent>;
    @ViewChildren('columnRefs') columnRefs: QueryList<ElementRef>;
    @Output() clickedColumn: EventEmitter<string> = new EventEmitter();
    private columnHeaderActive: ColumnHeaderItemComponent;

    ngAfterViewInit ()
    {
        this.columnHeaderActive = this.columnHeaders.toArray()
            .find((ch: ColumnHeaderItemComponent) =>
                ch.sorterKey === this.initSorterKey
            );
        this.updateUI();
    }

    ngOnChanges (changes: SimpleChanges): void
    {
        this.uiDirection = changes.direction.currentValue;
        if (changes.direction.previousValue !== undefined)
        {
            this.updateUI();
        }
    }

    onClickColumn = (columnHeader: ColumnHeaderItemComponent): void =>
    {
        this.columnHeaderActive = columnHeader;
        this.clickedColumn.emit(columnHeader.sorterKey);
        this.updateUI();
    };

    private updateUI (): void
    {
        this.columnHeaders.toArray()
            .forEach((ch: ColumnHeaderItemComponent) =>
                ch.active = false
            );
        this.columnHeaderActive.active = this.uiDirection !== 0;
    }
}
